/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { TldInfo } from "../../models/tld-info";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetTlds$Params {}

export function getTlds(
  http: HttpClient,
  rootUrl: string,
  params?: GetTlds$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<TldInfo>>> {
  const rb = new RequestBuilder(rootUrl, getTlds.PATH, "get");
  if (params) {
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TldInfo>>;
    }),
  );
}

getTlds.PATH = "/surfdomeinen/info/tlds";
